import { render, staticRenderFns } from "./GenericGridCard.vue?vue&type=template&id=90eddb70&scoped=true&"
import script from "./GenericGridCard.vue?vue&type=script&lang=ts&"
export * from "./GenericGridCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90eddb70",
  null
  
)

export default component.exports